/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class SystemCategories {
  text: string;
  value: number;

  static getSystemCategories(): SystemCategories[] {
    return categories as SystemCategories[];
  }
}

const categories = [
  { text: 'Conduit', value: 1 },
  { text: 'FieldFabConduit', value: 2 },
  { text: 'Ladder Cable Tray', value: 3 },
  { text: 'Channel Cable Tray', value: 4 },
  { text: 'Wire Mesh Cable Tray', value: 5 },
  { text: 'BusWay', value: 6 },
  { text: 'WireWay', value: 7 },
];
